'use strict';
/**
 * Truncates text and adds a show more button toggle after truncation.
 * See Truncate.js for more details.
 */

var $ = require('js/sw-jquery/sw-jquery');
var Truncate = require('js/lib/views/Truncate');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-truncate]').each(function() {
    var $el = $(this);

    new Truncate({
      el: $el
    });

  });

};
